import { RewardDetails, SubscriptionRewardDetails } from "~/server/types/brand";

export function TDOfferConstructText(props: {
  type: "ONE_TIME_REWARD" | "SUBSCRIPTION_REWARD" | undefined;
  oneTimeRewardDetails: RewardDetails | undefined;
  subscriptionRewardDetails: SubscriptionRewardDetails[] | undefined;
  description?: string | null;
}) {
  if (props.description) {
    return <div class="w-full text-center" innerHTML={props.description}></div>;
  }
  if (props.type === "ONE_TIME_REWARD") {
    if (props.oneTimeRewardDetails?.amountUnit === "PERC") {
      return (
        <>
          <span class="text-[#24DD7D]">
            Get instant {props.oneTimeRewardDetails.value}% off,
          </span>{" "}
          up to ₹{props.oneTimeRewardDetails.maxAmount} on your favourite brand
        </>
      );
    } else if (props.oneTimeRewardDetails?.amountUnit === "ABS") {
      return (
        <>
          <span class="text-[#24DD7D]">
            Get instant ₹{props.oneTimeRewardDetails.maxAmount} off,
          </span>{" "}
          on your favourite brand
        </>
      );
    }
  } else if (props.type === "SUBSCRIPTION_REWARD") {
    if (
      props.subscriptionRewardDetails?.[0]?.rewardDetails.amountUnit === "PERC"
    ) {
      const rewardValues =
        props.subscriptionRewardDetails.map(
          (reward) => reward.rewardDetails.value
        ) || [];
      const [lower, higher] = [...rewardValues].sort((a, b) => a - b);
      const maxAmount = Math.max(
        ...(props.subscriptionRewardDetails.map(
          (reward) => reward.rewardDetails.maxAmount
        ) || [0])
      );
      return (
        <>
          <span class="text-[#24DD7D]">
            Get{" "}
            {rewardValues.length === 1 ? `${lower}%` : `${lower}%-${higher}%`}{" "}
            off,
          </span>{" "}
          up to ₹{maxAmount} every month on your favourite brand
        </>
      );
    } else if (
      props.subscriptionRewardDetails?.[0]?.rewardDetails.amountUnit === "ABS"
    ) {
      const maxAmount = Math.max(
        ...(props.subscriptionRewardDetails.map(
          (reward) => reward.rewardDetails.maxAmount
        ) || [0])
      );
      return (
        <>
          <span class="text-[#24DD7D]">Get up to ₹{maxAmount} off,</span> every
          month on your favourite brand
        </>
      );
    }
  }
}

export function TdExlusiveOfferText() {
  return (
    <span class="font-jakartaSans text-[14px] text-normal text-white">
      Exclusive offer on your NeuCard
    </span>
  );
}
